import styled from 'styled-components';
import UserInitials from '@/trio-ui/UserInitials';

export const CustomUserInitials = styled(UserInitials)`
  width: 24px;
  height: 24px;
  margin: 0;
  margin-right: 8px;
`;

export const ThinBar = styled.div<{
  width: number;
  background: string;
}>`
  position: relative;
  width: ${(props) => props.width}%;
  height: 8px;
  background-color: ${(props) => props.background};
  &:not(&:last-of-type) {
    margin-bottom: 6px;
  }
`;

export const Row = styled.div`
  position: relative;
  width: 100%;
  height: 36px;
  background-color: #f7f7f7;
  border: 1px solid ${(props) => props.theme.colors['neutral-30']};
  border-radius: 4px;
  padding-left: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Label = styled.div`
  color: ${(props) => props.theme.colors['neutral-100']};
  font-weight: 400;
  font-size: 14px;
  position: relative;
`;

export const Container = styled.div`
  &:not(&:last-of-type) {
    margin-bottom: 12px;
  }
`;

export const Value = styled.div`
  color: ${(props) => props.theme.colors['primary-90']};
  color: #001b4b;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  position: absolute;
  right: 0;
  top: -5px;
  right: -25px;
`;

export const Lines = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: calc(100% - 110px);
  padding-right: 40px;
`;
